import styled from "@emotion/styled";
import { AppBar, Box, Container, Toolbar } from "@mui/material";
import { css, Global } from "@emotion/react";
import theme from "../../theme";
import { color, hover } from "framer-motion";

const StyledContainer = styled(Container)`
  padding: 0px 0px !important;
`;
const StyledToolbar = styled(Toolbar)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 !important;
`;

const StyledAppBar = styled(AppBar)`
  background-color: ${theme.colors.background.paper};
  color: black;
  position: fixed;
  width: 100%;
  align-items: center;
  box-shadow: none !important;
  padding: 0px 100px !important;
  @media (max-width: 1024px) {
    padding: 0px 50px !important;
  }

  @media (max-width: 768px) {
    padding: 0px 20px !important;
  }
`;

const logoStyle = {
  fontSize: "35px",
  fontWeight: 700,
  fontFamily: "'Rajdhani', sans-serif",
  background: theme.colors.text.primary,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  textDecoration: "none",
  marginRight: "100px",

  "@media (max-width: 1024px)": {
    marginRight: "50px",
  },

  "@media (max-width: 768px)": {
    fontSize: "28px",
    marginRight: "20px",
  },
};

const trademark = {
  fontSize: "10px",
  verticalAlign: "top",
  fontFamily: "'Rajdhani', sans-serif",
};
const navButton = {
  my: 2,
  color: theme.colors.text.primary,
  textTransform: "capitalize",
  fontSize: "16px",
  "&:hover": {
    color: theme.colors.primary,
    backgroundColor: "transparent",
  },
};

const signInButton = {
  backgroundColor: "white",
  color: "black",
  minWidth: "90px",
  borderRadius: "12px",
  height: "40px",
  fontSize: "14px",
  border: "1px solid #EDEEF0",
  "&:hover": {
    border: `1px solid ${theme.colors.buttonhover}`,
    color: "red",
  },
  width: "100%",
};

const trialButton = {
  backgroundColor: `${theme.colors.background.paper}`,
  color: "white",
  minWidth: "110px",
  height: "40px",
  borderRadius: "12px",
  border: "1px solid #ffff",
  "&:hover": {
    backgroundColor: `${theme.colors.primary}`,
    color: "white",
    border: "none",
  },
  width: "100%",
  color: "white",
};

const SC = {
  StyledContainer,
  StyledToolbar,
  StyledAppBar,
  logoStyle,
  navButton,
  signInButton,
  trialButton,
  trademark,
};

export default SC;
